export default {
  companyListInfo: {},
  companyList: [],
  companyInfo: {},
  memberList:[]
}
